<template>
  <div class="container">
    <h3>{{ i18n.t('/ManagerApproval/Headers/Title') || 'Te beoordelen orders' }}</h3>

    <manager-approval-filter @update="onUpdateFilters" />

    <div class="overview-block">
      <div class="header row">
        <div class="title">
          {{ i18n.t('/ManagerApproval/Headers/Configuration') || 'Configuratie' }}
        </div>
        <div class="customer">{{ i18n.t('/ManagerApproval/Headers/Customer') || 'Klant' }}</div>
        <div class="salesemployee">
          {{ i18n.t('/ManagerApproval/Headers/Salesperson') || 'Verkoper' }}
        </div>
        <div class="status">{{ i18n.t('/ManagerApproval/Headers/Status') || 'Status' }}</div>
        <div class="actions" />
      </div>
      <ul>
        <manager-approval-row v-for="order in orders" :key="order.QuoteId" :quote="order" />
      </ul>
    </div>

    <div class="loaderWrapper">
      <loader v-if="isLoading" />
    </div>

    <div v-if="error" class="error-message">
      <p>{{ error }}</p>
      <app-button @click="retryLoad">{{
        i18n.t('/Common/Retry') || 'Opnieuw proberen'
      }}</app-button>
    </div>

    <div v-if="canLoadMore">
      <app-button
        data-qa="load-more-approvals-button"
        type="button"
        button-type="primary"
        :disabled="isLoading"
        @click="loadMore()"
      >
        {{ i18n.t('/Dashboard/LoadMore') || 'Meer laden' }}
      </app-button>
    </div>

    <div v-if="orders.length === 0 && !isLoading && !error" class="no-orders">
      <p>{{ i18n.t('/ManagerApproval/NoOrders') || 'Geen orders ter beoordeling' }}</p>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import Loader from '@/components/generic/presentational/atoms/loader/Loader.vue'
import ManagerApprovalRow from './ManagerApprovalRow.vue'
import ManagerApprovalFilter from './ManagerApprovalFilter.vue'
import AppButton from '@/components/generic/presentational/atoms/appButton/AppButton.vue'

export default {
  name: 'ManagerApprovalOverview',
  components: {
    Loader,
    ManagerApprovalRow,
    ManagerApprovalFilter,
    AppButton,
  },
  props: {
    establishmentId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
    }
  },
  computed: {
    ...mapState('managerApproval', {
      orders: 'orders',
      isLoading: 'isLoading',
      error: 'error',
    }),
    ...mapGetters('managerApproval', {
      canLoadMore: 'canLoadMore',
    }),
  },
  watch: {
    async establishmentId() {
      await this.fetchOrders({ reset: true, dealerId: this.establishmentId })
    },
  },
  async created() {
    await this.fetchOrders({ reset: true, dealerId: this.establishmentId })
  },
  beforeUnmount() {
    this.resetOrders()
  },
  methods: {
    ...mapActions('managerApproval', ['fetchOrders', 'resetOrders']),
    async loadMore() {
      await this.fetchOrders({ reset: false, dealerId: this.establishmentId })
    },
    async onUpdateFilters() {
      await this.fetchOrders({ reset: true, dealerId: this.establishmentId })
    },
    async retryLoad() {
      await this.fetchOrders({ reset: true, dealerId: this.establishmentId })
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  @include center;
  display: grid;
  row-gap: 20px;
}

:deep() {
  .row {
    border-bottom: 1px solid #dae2e5;
    padding: 0.5rem;
    grid-column-gap: 0.5rem;
    display: grid;
  }

  .row {
    grid-template-columns: 13fr repeat(3, 10fr) 6fr;
    grid-template-areas: 'title customer salesemployee status actions';
  }

  li.row:hover {
    background-color: #fafbfc;
    cursor: pointer;
  }
}

.header {
  background-color: #f1f4f5;
  font-weight: $font-weight-bold;
}

ul {
  list-style: none outside;
}

.loaderWrapper {
  display: grid;
}

.error-message {
  text-align: center;
  color: #d32f2f;
  padding: 1rem;
}

.no-orders {
  text-align: center;
  color: #666;
  padding: 2rem;
  font-style: italic;
}
</style>
